<template>
  <div class="job-custom-field-mapping-type-container">
    <div v-if="showSalaryType" class="salary-type-container common-container">
      <label class="common-label">{{ $t(`${i18nPrefix}.label.salaryType`) }}</label>
      <div class="common-value">
        <el-select v-model="jobCustomFieldMappingVal.salaryType.type" disabled>
          <el-option :value="SALARY_PAYMENT_TYPE_OPTION.DEFAULT_VALUE" :label="$t(`${i18nPrefix}.label.defaultValue`)"></el-option>
        </el-select>
        <el-select
          v-model="jobCustomFieldMappingVal.salaryType.value"
          ref="salaryTypeRef"
          @focus="clearError('salaryTypeRef')"
        >
          <el-option
            v-for="(item, index) in salaryTypeList"
            :key="index"
            :value="item.id"
            :label="getI18nPropertyValue(item, 'cn_name', 'name')"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="min-salary-container common-container">
      <label class="common-label">{{ $t(`${i18nPrefix}.label.minSalary`) }}</label>
      <div class="common-value">
        <el-select v-model="jobCustomFieldMappingVal.minSalary.type">
          <el-option
            v-for="(option, index) in salaryTypeOptionList"
            :key="index"
            :label="option.label"
            :value="option.value"
            :disabled="option.disabled"
          />
        </el-select>
        <el-input
          v-if="jobCustomFieldMappingVal.minSalary.type === SALARY_TYPE_OPTION.FIXED_VALUE"
          v-model="jobCustomFieldMappingVal.minSalary.value"
          ref="minSalaryRef"
          :placeholder="$t(`${i18nPrefix}.placeholder.minSalary`)"
          @focus="clearError('minSalaryRef')"
        >
        </el-input>
        <div v-if="jobCustomFieldMappingVal.minSalary.type === SALARY_TYPE_OPTION.CUSTOM_FIELDS" class="job-custom-field">
          <el-select
            v-model="jobCustomFieldMappingVal.minSalary.customFiledValue"
            filterable
            ref="minSalaryRef"
            @focus="clearError('minSalaryRef')"
          >
            <el-option
              v-for="(item, index) in jobCustomFieldList"
              :key="index"
              :label="item.i18nName"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="max-salary-container common-container">
      <label class="common-label">{{ $t(`${i18nPrefix}.label.maxSalary`) }}</label>
      <div class="common-value">
        <el-select v-model="jobCustomFieldMappingVal.maxSalary.type">
          <el-option
            v-for="(option, index) in salaryTypeOptionList"
            :key="index"
            :label="option.label"
            :value="option.value"
            :disabled="option.disabled"
          />
        </el-select>
        <el-input
          v-if="jobCustomFieldMappingVal.maxSalary.type === SALARY_TYPE_OPTION.FIXED_VALUE"
          v-model="jobCustomFieldMappingVal.maxSalary.value"
          ref="maxSalaryRef"
          :placeholder="$t(`${i18nPrefix}.placeholder.maxSalary`)"
          @focus="clearError('maxSalaryRef')"
        >
        </el-input>
        <div v-if="jobCustomFieldMappingVal.maxSalary.type === SALARY_TYPE_OPTION.CUSTOM_FIELDS" class="job-custom-field">
          <el-select
            v-model="jobCustomFieldMappingVal.maxSalary.customFiledValue"
            filterable
            ref="maxSalaryRef"
            @focus="clearError('maxSalaryRef')"
          >
            <el-option
              v-for="(item, index) in jobCustomFieldList"
              :key="index"
              :label="item.i18nName"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div
      v-if="!hiddenSalaryMonth"
      class="salary-months-container common-container"
    >
      <label class="common-label">{{ $t(`${i18nPrefix}.label.salaryMonths`) }}</label>
      <div class="common-value">
        <el-select
          v-model="jobCustomFieldMappingVal.salaryMonth.type"
          disabled
        >
          <el-option :value="SALARY_MONTHS_OPTION.DEFAULT_VALUE" :label="$t(`${i18nPrefix}.label.defaultValue`)"></el-option>
        </el-select>
        <el-select v-model="jobCustomFieldMappingVal.salaryMonth.value" ref="salaryMonthRef" @focus="clearError('salaryMonthRef')">
          <el-option
            v-for="(item, index) in salaryMonthList"
            :key="index"
            :value="item.id"
            :label="getI18nPropertyValue(item, 'cn_name', 'name')"
          ></el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { getI18nPropertyValue } from '@/i18n'

const MAPPING_TYPE = {
  JOB_CUSTOM_FIELDS: 'JOB_CUSTOM_FIELDS',
  CUSTOM_MAPPING: 'CUSTOM_MAPPING'
}

const SALARY_PAYMENT_TYPE_OPTION = {
  DEFAULT_VALUE: 1
}

const SALARY_TYPE_OPTION = {
  FIXED_VALUE: 1,
  CUSTOM_FIELDS: 2
}

const SALARY_MONTHS_OPTION = {
  DEFAULT_VALUE: 1
}

export default {
  components: {
  },
  props: {
    jobCustomFieldMappingVal: {
      type: Object,
      require: true
    },
    showSalaryType: {
      type: Boolean,
      default: false
    },
    hiddenSalaryMonth: {
      type: Boolean,
      default: false
    },
    salaryTypeList: {
      type: Array,
      default: () => []
    },
    salaryMonthList: {
      type: Array,
      default: () => []
    },
    jobCustomFieldList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      MAPPING_TYPE,
      SALARY_PAYMENT_TYPE_OPTION,
      SALARY_TYPE_OPTION,
      SALARY_MONTHS_OPTION,
      mappingTypeValue: MAPPING_TYPE.CUSTOM_MAPPING,
      getI18nPropertyValue,
      i18nPrefix: 'admin.company.jobPosting'
    }
  },
  computed: {
    salaryTypeOptionList () {
      const optionList = [
        {
          label: this.$t(`${this.i18nPrefix}.label.fixedValue`),
          value: SALARY_TYPE_OPTION.FIXED_VALUE
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.customFields`),
          value: SALARY_TYPE_OPTION.CUSTOM_FIELDS,
          disabled: !this.jobCustomFieldList || this.jobCustomFieldList.length < 1
        }
      ]
      return optionList
    },
    isCustomMapping () {
      return this.mappingTypeValue === MAPPING_TYPE.CUSTOM_MAPPING
    }
  },
  methods: {
    validate () {
      let errorNames = []
      _.forEach(this.jobCustomFieldMappingVal, (item, key) => {
        const noValue = item.type === SALARY_TYPE_OPTION.FIXED_VALUE && !item.value
        const noCustomFiledValue = item.type === SALARY_TYPE_OPTION.CUSTOM_FIELDS && !item.customFiledValue
        if (noValue || noCustomFiledValue) {
          errorNames.push(`${key}Ref`)
        }
      })
      if (!this.showSalaryType) {
        errorNames = _.filter(errorNames, item => item !== 'salaryTypeRef')
      }
      if (this.hiddenSalaryMonth) {
        errorNames = _.filter(errorNames, item => item !== 'salaryMonthRef')
      }
      if (errorNames.length > 0) {
        this.setError(errorNames)
        return false
      }
      return true
    },
    formatRef (ref) {
      if (Array.isArray(ref)) {
        return ref[0]
      }
      return ref
    },
    setError (refNames, noNextTick) {
      if (!refNames || refNames.length < 1) {
        return
      }
      const firstRefName = refNames[0]
      const firstRef = this.formatRef(this.$refs[firstRefName])
      if (!firstRef) {
        if (noNextTick) {
          throw new Error(`can not found ref with name: ${firstRefName}`)
        } else {
          this.$nextTick(() => {
            this.setError(refNames, true)
          })
        }
        return
      }
      _.forEach(refNames, name => {
        const ref = this.formatRef(this.$refs[name])
        const el = ref.$el || ref
        el.classList.add('has-error')
      })
      const firstEl = firstRef.$el || firstRef
      firstEl.scrollIntoView({ block: 'center', behavior: 'smooth' })
      if (firstRefName === 'defaultValue') {
        this.$message.error(this.$t(`${this.i18nPrefix}.message.defaultIsRequired`))
      } else {
        this.$message.error(this.$t(`${this.i18nPrefix}.message.mappingHasEmpty`))
      }
    },
    clearError (refName, noNextTick) {
      const ref = this.$refs[refName]
      if (!ref) {
        if (noNextTick) {
          throw new Error(`can not found ref with name: ${refName}`)
        } else {
          this.$nextTick(() => {
            this.clearError(refName, true)
          })
        }
        return
      }
      const el = ref.$el || ref
      el.classList.remove('has-error')
    }
  }
}
</script>

<style lang="scss" scoped>
.job-custom-field-mapping-type-container {
  .common-container {
    display: flex;
    margin: 15px 0;

    .job-custom-field {
      width: 100%;
    }
  }

  .common-label {
    width: 110px;
    line-height: 32px;
    margin-right: 10px;
  }

  .common-value {
    display: flex;
    flex: 1;

    ::v-deep {
      .has-error {
        .el-input__inner {
          border-color: #f56c6c;

          &:focus {
            border-color: #f56c6c;
          }
        }
      }

      .el-select:first-child {
        margin-right: 30px;
      }

      .el-select:last-child {
        width: 100%;
      }
    }
  }
}
</style>
